import designProductLuluran1 from "../images/portofolio/produk-luluran.webp";
import designProductLuluran2 from "../images/portofolio/produk-luluran-2.webp";
import websiteGaleriInterior from "../images/portofolio/website-galeri-interior.webp";
import websiteNocturnoStore from "../images/portofolio/website-top-up.webp";
import hayApps from "../images/portofolio/hay-apps.webp";
import logoKprm from "../images/portofolio/komisi-pemilihan-raya-mahasiswa-logo.webp";
import logoHay from "../images/portofolio/hay-logo.webp";
import posterLombaBazarhmtifExpo from "../images/portofolio/poster-lomba-bazar-hmtif-expo.webp";
import posterLombaUiUxDesign from "../images/portofolio/poster-lomba-ui-ux-design.webp";
import posterNifc2k22Competition from "../images/portofolio/poster-nifc-2k22-competition.webp";
import posterTurnamentNifcCup1Football from "../images/portofolio/poster-turnament-nifc-cup-1-football.webp";
import posterTurnamentNifcCupMobileLegends from "../images/portofolio/poster-turnament-nifc-cup-mobile-legends.webp";
import posterTurnamentNifcMuru from "../images/portofolio/poster-turnament-nifc-muru.webp";

const portofolio = [
  {
    id: 1,
    name: "Product Design",
    creator: "Graphic Designer Creasnap",
    img: designProductLuluran1,
    link: "#",
  },
  {
    id: 2,
    name: "Product Design",
    creator: "Graphic Designer Creasnap",
    img: designProductLuluran2,
    link: "#",
  },
  {
    id: 3,
    name: "Website",
    creator: "Graphic Designer Creasnap",
    img: websiteGaleriInterior,
    link: "#",
  },
  {
    id: 4,
    name: "Website",
    creator: "Software Developer Creasnap",
    img: websiteNocturnoStore,
    link: "https://nocturnostore.com",
  },
  {
    id: 5,
    name: "Mobile Apps",
    creator: "Software Developer Creasnap",
    img: hayApps,
    link: "https://github.com/Hay-Hair-Healthy/mobile_repo",
  },
  {
    id: 6,
    name: "Logo Design",
    creator: "Graphic Designer Creasnap",
    img: logoKprm,
    link: "#",
  },
  {
    id: 7,
    name: "Logo Design",
    creator: "Graphic Designer Creasnap",
    img: logoHay,
    link: "#",
  },
  {
    id: 8,
    name: "Poster Design",
    creator: "Graphic Designer Creasnap",
    img: posterLombaBazarhmtifExpo,
    link: "#",
  },
  {
    id: 9,
    name: "Poster Design",
    creator: "Graphic Designer Creasnap",
    img: posterLombaUiUxDesign,
    link: "#",
  },
  {
    id: 10,
    name: "Poster Design",
    creator: "Graphic Designer Creasnap",
    img: posterNifc2k22Competition,
    link: "#",
  },
  {
    id: 11,
    name: "Poster Design",
    creator: "Graphic Designer Creasnap",
    img: posterTurnamentNifcCup1Football,
    link: "#",
  },
  {
    id: 12,
    name: "Poster Design",
    creator: "Graphic Designer Creasnap",
    img: posterTurnamentNifcCupMobileLegends,
    link: "#",
  },
  {
    id: 13,
    name: "Poster Design",
    creator: "Graphic Designer Creasnap",
    img: posterTurnamentNifcMuru,
    link: "#",
  },
];

export default portofolio;
